import React from "react";
import { colours } from "@shared/ui.design-system";

export const SuccessIcon = ({
  className,
  iconColor = colours.success.medium
}: {
  className?: string;
  iconColor?: string;
}) => (
  <svg
    className={className}
    viewBox="0 0 24 24"
    focusable="false"
    data-testid="SuccessIcon"
    width="20"
  >
    <circle cx="12" cy="12" r="10.5" fill={iconColor} />
    <path
      fill="#fff"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1677 7.65503C18.3181 7.79733 18.3248 8.03467 18.1825 8.18515L10.48 16.3302C10.4104 16.4037 10.314 16.446 10.2127 16.4475C10.1115 16.4489 10.0139 16.4093 9.94233 16.3377L5.82483 12.2202C5.67838 12.0737 5.67838 11.8363 5.82483 11.6898C5.97128 11.5434 6.20871 11.5434 6.35516 11.6898L10.2 15.5347L17.6375 7.66983C17.7798 7.51935 18.0172 7.51273 18.1677 7.65503Z"
    />
  </svg>
);
